import { ComponentStyleConfig, cssVar } from '@chakra-ui/react';
import { SongStatusType } from '../../../types/song';

const $pink0 = cssVar('chakra-colors-P-0');
const $pink10 = cssVar('chakra-colors-P-10');

const $blue0 = cssVar('chakra-colors-B-0');
const $blue10 = cssVar('chakra-colors-B-10');

const $orange0 = cssVar('chakra-colors-O-0');
const $orange10 = cssVar('chakra-colors-O-10');

const $green0 = cssVar('chakra-colors-G-0');
const $green10 = cssVar('chakra-colors-G-10');

const colorMap = {
  [SongStatusType.IN_CREATION]: {
    coverBg: 'P.20',
    cover: `conic-gradient(${$pink10.reference}, ${$pink0.reference})`,
    rotate: -0,
  },
  [SongStatusType.PITCHABLE]: {
    coverBg: 'B.20',
    cover: `conic-gradient(${$blue10.reference}, ${$blue0.reference})`,
    rotate: 90,
  },
  [SongStatusType.HOLD]: {
    coverBg: 'O.20',
    cover: `conic-gradient(${$orange10.reference}, ${$orange0.reference})`,
    rotate: 180,
  },
  [SongStatusType.RELEASED]: {
    coverBg: 'G.20',
    cover: `conic-gradient(${$green10.reference}, ${$green0.reference})`,
    rotate: -90,
  },
};

export const SongCover: ComponentStyleConfig = {
  baseStyle: ({ status }) => {
    const { coverBg, cover, rotate } = colorMap[status];
    return {
      bg: `${coverBg} !important`,
      rounded: 6,
      ' div': {
        height: '75%',
        width: '75%',
        background: cover,
        borderRadius: 'full',
        transform: `rotate(${rotate}deg)`,
      },
    };
  },
  sizes: {
    tiny: {
      width: '24px',
      height: '24px',
      minWidth: '24px',
      minHeight: '24px',
    },
    small: {
      width: '32px',
      height: '32px',
      minWidth: '32px',
      minHeight: '32px',
    },
    '38': {
      width: '38px',
      height: '38px',
      minWidth: '38px',
      minHeight: '38px',
    },
    medium: {
      rounded: 2,
      width: '40px',
      height: '40px',
      minWidth: '40px',
      minHeight: '40px',
    },
    big: {
      width: '128px',
      height: '128px',
      minWidth: '128px',
      minHeight: '128px',
    },
  },
  variants: {},
  defaultProps: {
    size: 'big',
  },
};
